import React,{Component} from 'react';
import Logo from '../../../images/logo-black.png';
import Image from '../../../images/product.png';
import Width from '../../../images/width.png';
import Height from '../../../images/height.png';
import Length from '../../../images/length.png';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SimpleReactValidator from 'simple-react-validator';
import templateId from '../../../libraries/lang-id';
import language from '../../../libraries/label-lang';
import {history} from '../../../shared/configure-store';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import Copyright from '../../presentational/copyright';
import {toast, ToastContainer} from 'react-toastify';
import Api from '../../../libraries/api';
import AddIcon from '@material-ui/icons/Add';
import {connect} from "react-redux";
import {RootActions} from "../../../shared/root-action";
import {bindActionCreators} from "redux";
import AuthHelper from "../../../libraries/auth-helper";
import NumberFormat from 'react-number-format';

SimpleReactValidator.addLocale('indo', templateId);

const triggerThis = () => {
    window.onbeforeunload = confirmExit;
    function confirmExit()
    {
        return "show message";
    }
};
const disableTriggerThis = () => {
    window.onbeforeunload = null;
};

class Reservation extends Component {

    constructor(props) {

        super(props);

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.validatorAdd = new SimpleReactValidator(
            {
                locale: lang
            }
        );


        this.state = {
            loading: true,
            loading2: false,
            loading3: false,
            loadingProduct: true,
            loadingButton: false,
            loadingReservation: false,
            loadingChooseTime: false,
            step2: false,

            passed: false,

            showDialog: false,
            showDialogSummary: false,

            count: true,

            minutes: 15,
            seconds: 0,

            errors: [],
            error: '',

            timeout: '',

            countdown: '',

            time: '',
            products: [],

            productList: [],
            warehouseList: [],
            reservationList: [],
            storageList: [],

            selectedWarehouseAddress: '',

            image_name: '',
            skuNumber: '',
            name: '',
            storage: '',
            category: '',
            category_other: '',
            width: '',
            height: '',
            length: '',
            weight: '',
            supliedPackaging: '',
            otherpackaging: '',
            shelfLife: '',
            image: '',
            image_file: '',
            price: '',
            description: '',
            lockerSizeName: '',
            lockerSizeId: '',

            reservationId: '',
            warehouse: '',

            newlyCreatedProductId: '',
            currentIndexProductList: '',

        };

        this.handleAdd = this.handleAdd.bind(this);
        this.handleAddProduct = this.handleAddProduct.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleChangeAdd = this.handleChangeAdd.bind(this);
        this.checkSlot = this.checkSlot.bind(this);

        this.checkSlot = _.debounce(this.checkSlot, 1000);
    }

    componentDidMount(){

        document.title = 'Fresh Factory - Pengiriman';

        if(AuthHelper.getProfile()) {
            let name = AuthHelper.getProfile() ? AuthHelper.getProfile().firstName : '';
            this.setState({
                userName: name,
            });

            if(AuthHelper.getProfile().tenantUser === null) {
                this.showMessage(false, 'Harap isi data perusahaan');
                history.push('/company');
            }
        }

        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

        Api.get('/storage').then(resp => {
            if (resp.data) {

                this.setState({
                    storageList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

        this.handleAdd();
        this.__fetchProducts();

    };

    componentWillUnmount() {
        clearInterval(this.myInterval);
        disableTriggerThis();
    }

    componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    handleStep1 (e, prop){
        if(prop === 'warehouse') {

            if(e.target.value){

                let temp = '';

                _.forEach(this.state.warehouseList, function(item,index){
                    if(e.target.value === item.id){
                        temp = item.address1+' '+item.address2+', '+item.city+', '+item.state+', '+item.postalCode;
                    }
                });

                this.setState({

                    [prop]: e.target.value,
                    selectedWarehouseAddress: temp,

                    productList: [],
                    reservationId: '',
                    time: '',

                    loading2: true,
                    step2: false,

                }, () => {
                    this.__fetchReservationList(e.target.value);
                });

            }

        }else if(prop === 'time'){

            if(e.target.value){

                this.setState({

                    [prop]: e.target.value,
                    loadingChooseTime: true,

                });
                let params = {
                    warehouseId: this.state.warehouse,
                    reservationDate: e.target.value,
                };

                Api.post('/reservation/times', params).then(resp => {

                    if(resp.status === 'success') {

                        triggerThis();

                        this.setState({
                            reservationId: resp.data.id,
                            step2: true,
                            loadingChooseTime: false,
                        });

                        this.__startTimer();
                    }

                }).catch(err => {

                    this.showMessage(false, err.message);

                    this.setState({
                        loadingChooseTime: false,
                    });

                });
            }
        }else{

            this.setState({
                [prop]: e.target.value
            });

        }
    };

    __startTimer = () => {
        clearInterval(this.myInterval);
        this.setState({
            minutes: 15,
            seconds: 0,
        }, () => {
            this.__timerFn();
        });
    };

    __timerFn = () =>{
        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state;

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval);
                    this.__resetData();
                    return false;
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    };

    __resetData = () => {
        this.setState({
            warehouse: '',
            time: '',
            products: [],
            selectedWarehouseAddress: '',
            step2: false,
        });
    };

    __fetchReservationList = (id) => {
        let data = {warehouseId: id};
        Api.post('/reservation/available',data).then(resp => {

            if (resp.data) {
                this.setState({
                    reservationList: resp.data,
                    loading2: false
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };

    __fetchLockerSize = (w,h,l,s) => {

        this.setState({

            loading3: true

        });

        let data = {
            width: w,
            height: h,
            length: l,
            storage: s,
        };
        Api.post('/lockersize/find',data).then(resp => {

            if (resp.data.length === 0) {
                this.setState({
                    lockerSizeName: 0,
                    loading3: false
                });

                return false
            }
            if (resp.data) {
                this.setState({
                    lockerSizeName: resp.data.name,
                    lockerSizeId: resp.data.id,
                    loading3: false
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };

    __fetchProducts = (state) => {
        state = typeof state === 'undefined' ? false : state;
        Api.get('/products?limit=0').then(resp => {

            if (resp.data) {
                this.setState({
                    products: resp.data,
                    loadingProduct: false
                },()=>{
                    if(state){
                        this.__inputNewlyCreatedProduct();
                    }
                });
            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loadingProduct: false
            })
        });
    };

    __inputNewlyCreatedProduct = () => {
        let currentIndex = this.state.currentIndexProductList;
        let id = this.state.newlyCreatedProductId;
        let productList = this.state.productList;
        _.forEach(productList, function(v,k){
            if(k === currentIndex){
                v['id'] = id;
            }
        });

        this.setState({
            productList: productList,
            showDialog: false,
            loadingButton: false,
        });

    };

    handleAdd = (e) => {
        this.setState({
                errors: {},
            }
        );

        let exp = this.state.productList;
        let temp = {
            productId : '',
            name : '',
            sku : '',
            quantity : '',
            slot : false,
        };

        exp.push(temp);
        this.setState({
                productList: exp,
            }, () => {
            clearTimeout(this.state.timeout);
            }
        );
    };

    handleAddProduct = (e) => {
        e.preventDefault();

        if (!this.validatorAdd.allValid()) {

            this.setState({
                    errors: this.validatorAdd.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true
            }
        );

        let formData = new FormData();
        formData.append('skuNumber', this.state.skuNumber);
        formData.append('name', this.state.name);
        formData.append('storage', this.state.storage);
        formData.append('category', this.state.category === 'Other' ? this.state.category_other : this.state.category);
        formData.append('width', this.state.width);
        formData.append('height', this.state.height);
        formData.append('length', this.state.length);
        formData.append('weight', this.state.weight);
        formData.append('supliedPackaging', this.state.supliedPackaging === 'Other' ? this.state.otherpackaging : this.state.supliedPackaging);
        formData.append('shelfLife', this.state.shelfLife);
        formData.append('description', this.state.description);
        formData.append('lockerSizeId', this.state.lockerSizeId);
        formData.append('price', this.state.price);
        formData.append('reservationId', this.state.reservationId);
        if(this.state.image_file) {
            formData.append('image', this.state.image_file);
        }

        Api.putFile('/products',{
            method: 'POST',
            body: formData
        }).then(resp => {

            this.setState({
                newlyCreatedProductId: resp.data.id,

                skuNumber: '',
                name: '',
                storage: '',
                category: '',
                category_other: '',
                width: '',
                height: '',
                length: '',
                weight: '',
                supliedPackaging: '',
                otherpackaging: '',
                shelfLife: '',
                description: '',
                lockerSizeId: '',
                lockerSizeName: '',
                price: '',
                image_file: '',
                image: '',
                image_name: '',
                reservationId: this.state.reservationId

            },()=>{
                this.__fetchProducts(true);
            });

            this.showMessage(true, 'Product successfully added');

        }).catch(err => {
            if(err.errors) {
                this.setState({
                        errors: err.errors,
                        loadingButton: false
                    }
                );
                this.showMessage(false, 'Invalid format data');
            }else {
                this.setState({
                        loadingButton: false
                    }
                );
                this.showMessage(false, err.message);
            }
        });

        this.__startTimer();

    };

    handleUpload = e => {

        let temp = _.get(e,'target.files[0]',false);

        this.setState({
            errors: {image:''},
        });

        if(temp){
            if(e.target.files[0].size > 999999){

                this.setState({
                    errors: {
                        image: 'This file is too big. Maximum size is 1MB.'
                    },
                });

            }else if(e.target.files[0].name.toLowerCase().search('.jpeg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.jpg') === -1  &&
                e.target.files[0].name.toLowerCase().search('.png') === -1){

                this.setState({
                    errors: {
                        image: 'This file is invalid. Only accept .jpg, .jpeg and .png'
                    },
                });

            }else{

                this.setState({
                    image: URL.createObjectURL(e.target.files[0]),
                    image_file: e.target.files[0],
                    image_name: e.target.files[0].name,
                });

            }
        }
    };

    handleChangeAdd = (e, prop, idx) => {

        let data = this.state.productList;
        let name = '';
        let sku = '';

        if(prop == 'quantity'){
            if(e.target.value <= 0){
                e.target.value = 1;
            }
        }

        if(e.target.value === '0000'){
            this.handleOpen();
        }

        if(prop === 'productId') {
            name = this.filterName(e.target.value);
            sku = this.filterSKU(e.target.value);
        }
        _.forEach(data, function(v,k){

            if(k === idx){
                v[prop] = e.target.value;

                if(prop === 'productId') {
                    v.quantity = 1;//'';
                    v.name = name;
                    v.sku = sku;

                    if(e.target.value === '0000'){
                        v.productId = '';
                    }
                }
            }
        });

        this.setState({
            errors: {},
            productList: data,
            currentIndexProductList: idx
        },() =>
        {
            this.__startTimer();
            let count = this.state.count;

            if(prop === 'quantity') {
                //this.checkSlot();

                if(count) {
                    setTimeout(()=> {
                        this.checkSlot();
                        this.setState({
                            count: true,
                        });
                    }, 3000);
                }

                this.setState({
                    count: false,
                });
            }
        });


    };

    checkSlot = () => {

        this.setState({
            loadingReservation: true,
            passed: false,
        });

        let temp = this.state.productList;
        let temp2 = _.filter(temp, function(o) { return o.quantity; });

        let params = {
            warehouseId: this.state.warehouse,
            reservationId: this.state.reservationId,
            products: temp2,
        };

        Api.post('/reservations', params).then(resp => {

            if(resp.status === 'success') {
                let products = resp.data;
                let temp = this.state.productList;
                if(products.length > 0){
                    let check = true;
                    _.forEach(products, function(v,k){
                        _.forEach(temp, function(item,key){
                            if(item.productId === v.product_id) {
                                if(v.available === 1) {
                                    item.slot = true;
                                }else {
                                    item.slot = false;
                                    check = false;
                                }
                            }
                        });

                    });

                    this.setState({
                        productList: temp,
                        loadingReservation: false,
                        passed:check
                    });
                }
                this.__startTimer();

            }

        }).catch(err => {

            this.setState({
                loadingReservation: false,
            });

            this.showMessage(false, err.message);

        });
    };

    handleDelProd (e, id){
        this.setState({
                errors: {},
            }
        );

        let data = this.state.productList.filter((e, idx) =>idx !== id);

        this.setState({
            productList: data,
        },() =>
        {
            this.checkSlot();
        });
    };

    handleGo  = (link) => {
        history.push(link);
    };

    handleOpen = () => {
        this.setState({
            showDialog :true,
        })
    };
    handleOpenSummary = () => {
        this.setState({
            showDialogSummary :true,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog :false,
            showDialogSummary :false,
        })
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        }, () => {

            this.__startTimer();
            if(prop === 'width' || prop === 'height' || prop === 'length' || prop === 'storage' ){
                if(this.state.width && this.state.height && this.state.length && this.state.storage){
                    this.__fetchLockerSize(this.state.width,this.state.height,this.state.length,this.state.storage)
                }
            }

        });

    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    filterName = (id) => {
        let all = this.state.products.filter((item) => item.id === id);
        if(all.length > 0)
            return all[0].name;
    };

    filterSKU = (id) => {
        let all = this.state.products.filter((item) => item.id === id);
        if(all.length > 0)
            return all[0].skuNumber;
    };

    handleReservation = () => {

        this.setState({
            passed: false,
        });

        let params = {
            reservationId: this.state.reservationId,
        };

        Api.post('/reservation/submit', params).then(resp => {

            if(resp.status === 'success') {

                disableTriggerThis();

                this.setState({
                    passed: true,
                });

                history.push('/reservation-success/'+this.state.reservationId);
            }


        }).catch(err => {

            this.setState({
                passed: true,
            });


            this.showMessage(false, err.message);

        });
    };

    NumberFormatCustom = (props) => {
        const { inputRef, onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                fixedDecimalScale={false}
                thousandSeparator
                isNumericString
            />
        );
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='main'>
                <section>
                    <div className='container reservation'>
                        <div className='row justify-content-center'>
                            <div className='col-md-10 col-lg-8 text-center'>
                                <img src={Logo} alt='logo' className='img-logo' />
                                <div className='row mx-auto'>
                                    <div className='col-md-4'>
                                        <img src={Image} alt='logo' className='mb-2' />
                                    </div>
                                    <div className='col-md-8 text-md-left'>
                                        <h2 className='text-big'>{text.reservation_welcome}{this.state.userName ? ', '+this.state.userName : ''}!</h2>
                                        <p className='mb-0 color-brow n-grey'>{text.reservation_paragraph1}?</p>
                                        <p className='mb-0 color-gunmetal p-12'>{text.reservation_paragraph2}</p>
                                    </div>
                                </div>
                                <div className='underline pt-3'> </div>
                                <h1 className='text-big pt-3 pt-md-5 mb-3'>{text.reservation_heading}</h1>

                                {this.state.minutes === 0 && this.state.seconds === 0 ? (
                                    <div className='alert-heading purple background-reddish p-12 color-white'>
                                        <i className='fas fa-exclamation-circle mr-3'> </i>
                                        {text.reservation_time_up}
                                    </div>
                                ) : (
                                    <div className='alert-heading purple background-faded-blue p-12 color-white'>
                                        <i className='fas fa-exclamation-circle mr-3'> </i> {text.reservation_timer}
                                        : {this.state.minutes}:{this.state.seconds < 10 ? `0${this.state.seconds}` : this.state.seconds}&nbsp;
                                        (15 {text.label_minute})
                                    </div>
                                )}

                                <div className='steps'>
                                    <p className=' mb-0'><b>{text.reservation_step} 1:</b></p>
                                    <p className='p-18 mb-0'><b>{text.reservation_step1_text}</b></p>
                                </div>
                                <form>
                                    <div className='form-group text-left position-relative'>
                                        <TextField
                                            select
                                            id='warehouse'
                                            name='warehouse'
                                            label={text.label_warehouse}
                                            onChange={(e) => this.handleStep1(e, 'warehouse')}
                                            value={this.state.warehouse}
                                            disabled={this.state.loading}
                                            fullWidth
                                        >
                                            {this.state.warehouseList.map((option, idx) => (
                                                <MenuItem key={idx} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.validator.message('warehouse', this.state.warehouse, 'required')}
                                        <div className='text-danger'>{this.state.errors.warehouse}</div>
                                        { this.state.loading && <i className='fa fa-spinner fa-spin spin-absolute'>&nbsp; </i> }
                                    </div>

                                    { this.state.warehouse && (
                                        <div>
                                            <div className='col-md-10 mx-auto'>
                                                <div className='card-cream'>
                                                    <div className='row mx-auto py-4 align-items-center'>
                                                        <div className='col-11 text-left p-10 color-brown-grey'>
                                                            <label className='mb-0'><i className='far fa-map pr-2'> </i> {text.label_warehouse_address}</label>
                                                            <p className='p-12 color-gunmetal mb-0'>{this.state.selectedWarehouseAddress}</p>
                                                        </div>
                                                        <div className='col-1'>
                                                            <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='form-group text-left date position-relative'>
                                                <TextField
                                                    select
                                                    id='time'
                                                    name='time'
                                                    label={text.label_time}
                                                    onChange={(e) => this.handleStep1(e, 'time')}
                                                    value={this.state.time}
                                                    disabled={this.state.loading2}
                                                    fullWidth
                                                >
                                                    {this.state.reservationList.map((option,idx) => (
                                                        <MenuItem key={idx} value={option.reservationDate}>
                                                            {option.reservationDateString}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                                {this.validator.message('time', this.state.time, 'required')}
                                                <div className='text-danger'>{this.state.errors.time}</div>
                                                { this.state.loading2 && <i className='fa fa-spinner fa-spin spin-absolute'>&nbsp; </i> }
                                            </div>
                                        </div>


                                    )}

                                </form>

                                {this.state.loadingChooseTime ?
                                    <div className='alert-heading background-green p-12 color-white mt-4 text-center'>
                                        <i className='fa fa-spinner fa-spin'> </i>
                                    </div>
                                    :
                                this.state.step2 &&
                                    <div className='alert-heading background-green p-12 color-white mt-4'>
                                        <i className='fas fa-exclamation-circle'> </i>&nbsp;{text.reservation_step1_alert}
                                    </div>
                                }

                                {this.state.step2 && (
                                    <div>
                                        <div className='steps'>
                                            <p className=' mb-0'><b>{text.reservation_step} 2:</b></p>
                                            <p className='p-18'><b>{text.reservation_step2_text}</b></p>
                                        </div>
                                        <p className='p-18 pt-3 mb-4'><b>{text.reservation_product}</b></p>

                                        <div className='row table-head'>
                                            <div className='col-6 col-md-3'><p className='mb-0 p-10' >{text.label_sku}<span className='d-none d-md-inline p-10'> SKU</span></p></div>
                                            <div className='col-md-3 d-none d-md-block'><p className='mb-0 p-10'>{text.label_product}</p></div>
                                            <div className='col-md-4 d-none d-md-block'><p className='mb-0 p-10'>{text.label_quantity}</p></div>
                                            <div className='col-md-1 d-none d-md-block'><p className='mb-0 p-10'>{text.label_slot}</p></div>
                                            <div className='col-md-1 d-none d-md-block'><p className='mb-0 p-10'>{text.label_delete}</p></div>
                                        </div>

                                        {
                                            this.state.productList.length > 0 &&
                                            this.state.productList.map(function (item, idx) {
                                                return <div className='row table-body background-white-grey pb-2' key={idx}>
                                                    <div className='col-6 col-md-3 position-relative'>
                                                        <TextField
                                                            select
                                                            id='productId'
                                                            name='productId'
                                                            label={text.label_sku}
                                                            onChange={(e) => this.handleChangeAdd(e, 'productId', idx)}
                                                            value={item.productId}
                                                            disabled={this.state.loadingProduct}
                                                            className='text-left'
                                                            fullWidth
                                                            inputProps={{
                                                                name: 'customName'
                                                            }}
                                                        >
                                                            {this.state.products.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                            <MenuItem value='0000' className='menu-btn'><i className='fas fa-plus'> </i> Tambah Produk</MenuItem>
                                                        </TextField>
                                                        {this.validator.message('productId-'+idx, item.productId, 'required')}
                                                        <div className='text-danger'>{this.state.errors['productId-'+idx]}</div>
                                                        { this.state.loadingProduct && <i className='fa fa-spinner fa-spin spin-absolute'>&nbsp; </i> }
                                                    </div>
                                                    <div className='col-6 col-md-3 '><p className='p-12 mb-0'>{item.name ? item.name : 'Nama produk'}</p></div>
                                                    <div className='col-6 col-md-4'>
                                                        <TextField
                                                            type='number'
                                                            id={'quantity-'+idx}
                                                            name={'quantity-'+idx}
                                                            onChange={(e) => this.handleChangeAdd(e, 'quantity', idx)}
                                                            label={text.label_quantity}
                                                            value={item.quantity}
                                                            fullWidth
                                                        />
                                                        {this.validator.message('quantity-'+idx, item.quantity, 'numeric|required')}
                                                        <div className='text-danger'>{this.state.errors['quantity-'+idx]}</div>
                                                    </div>
                                                    <div className='col-6 col-md-1'>
                                                        { this.state.loadingReservation ?
                                                            <i className='fa fa-spinner fa-spin p-12'> </i>
                                                        :
                                                            item.slot ?
                                                                <i className='fas fa-check-circle color-leaf p-12'> </i> :
                                                                <i className="fas fa-times-circle color-reddish p-12"> </i>
                                                        }
                                                    </div>
                                                    <div className='col-6 col-md-1'>
                                                        <button className='button-transparent' onClick={(e) => this.handleDelProd(e, idx)}>
                                                            <i className='fas fa-backspace color-reddish p-12'> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            }.bind(this))
                                        }

                                        <div className='row table-body mb-3'>
                                            <div className='col-12'>
                                                <Button
                                                    variant='contained'
                                                    color='secondary'
                                                    className='mt-3 mr-2 btn-block'
                                                    startIcon={<AddIcon />}
                                                    onClick={this.handleAdd}
                                                >
                                                    {text.button_add_list}
                                                </Button>
                                            </div>
                                        </div>
                                        <div className='row table-body mb-3'>
                                            <div className='col-12 text-left'>
                                                <p className='d-inline mr-3'><i className='fas fa-check-circle color-leaf p-12'> </i> {text.label_available}</p>
                                                <p className='d-inline'><i className="fas fa-times-circle color-reddish p-12"> </i> {text.label_unavailable}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className='row table-body justify-content-end mt-4'>
                                    <div className='col-md-6 text-right'>
                                         <Button
                                             variant='contained'
                                             className='btn-link mr-3'
                                             onClick={() => this.handleGo('/')}
                                         >{text.button_skip}</Button>

                                        <Button
                                            variant='contained'
                                            color='primary'
                                            className=''
                                            onClick={this.handleOpenSummary}
                                            disabled={!this.state.passed}
                                        >
                                            {text.button_next}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <ToastContainer autoClose={false} />
                <footer>
                    <p className='text-center'><Copyright /></p>
                </footer>
                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>{text.label_add_product}</DialogTitle>
                    <DialogContent>
                        <form name='add' id='addProduct' className='row' noValidate>
                            <div className='col-12 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                               type='text'
                                               id='skuNumber'
                                               name='skuNumber'
                                               label={text.label_sku}
                                               onChange={(e) => this.handleChange(e, 'skuNumber')}
                                               value={this.state.skuNumber}
                                               fullWidth
                                    />
                                    {this.validatorAdd.message('skuNumber', this.state.skuNumber, 'required')}
                                    <div className='text-danger'>{this.state.errors.skuNumber}</div>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='form-group position-relative'>
                                    <Tooltip
                                        arrow
                                        title={text.label_tooltip}
                                        placement='top'>
                                        <i className='fas fa-question-circle tooltip-icon'> </i>
                                    </Tooltip>
                                    <TextField
                                        type='text'
                                        id='imageFiles'
                                        name='imageFiles'
                                        label={text.label_upload}
                                        value={this.state.image_name}
                                        fullWidth
                                        autoComplete='off'
                                    />
                                    <label
                                        htmlFor="image"
                                        id="upload-image"
                                    >{text.label_browse}</label>
                                    <TextField
                                        accept='.jpg,.jpeg,.png'
                                        type='file'
                                        id='image'
                                        name='image'
                                        className='avatar d-none'
                                        onChange={this.handleUpload}
                                        fullWidth
                                    />
                                    {this.validatorAdd.message('image', this.state.image, 'required')}
                                    <div className='text-danger'>{this.state.errors.image}</div>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                        type='text'
                                        id='name'
                                        name='name'
                                        label={text.label_product}
                                        onChange={(e) => this.handleChange(e, 'name')}
                                        value={this.state.name}
                                        fullWidth
                                    />
                                    {this.validatorAdd.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className='col-md-6 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                               select
                                               id='storage'
                                               name='storage'
                                               label={text.label_storage}
                                               onChange={(e) => this.handleChange(e, 'storage')}
                                               value={this.state.storage}
                                               fullWidth
                                    >
                                      {/*  <MenuItem value='Frozen -20C'>
                                            Frozen -20C
                                        </MenuItem>*/}
                                        {this.state.storageList.map((option, idx) => (
                                            <MenuItem key={idx} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    {this.validatorAdd.message('storage', this.state.storage, 'required')}
                                    <div className='text-danger'>{this.state.errors.storage}</div>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='row align-items-center'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <TextField
                                                select
                                                id='category'
                                                name='category'
                                                label={text.label_category}
                                                onChange={(e) => this.handleChange(e, 'category')}
                                                value={this.state.category}
                                                fullWidth
                                            >
                                                <MenuItem value='Beras'>
                                                    Beras
                                                </MenuItem>
                                                <MenuItem value='Bumbu Dan Sambal'>
                                                    Bumbu Dan Sambal
                                                </MenuItem>
                                                <MenuItem value='Daging Ayam'>
                                                    Daging Ayam
                                                </MenuItem>
                                                <MenuItem value='Daging Sapi'>
                                                    Daging Sapi
                                                </MenuItem>
                                                <MenuItem value='Es Krim'>
                                                    Es Krim
                                                </MenuItem>
                                                <MenuItem value='Ikan Dan Hasil Laut'>
                                                    Ikan Dan Hasil Laut
                                                </MenuItem>
                                                <MenuItem value='Makanan Siap Masak'>
                                                    Makanan Siap Masak
                                                </MenuItem>
                                                <MenuItem value='Makanan Siap Saji'>
                                                    Makanan Siap Saji
                                                </MenuItem>
                                                <MenuItem value='Minuman'>
                                                    Minuman
                                                </MenuItem>
                                                <MenuItem value='Oleh-Oleh'>
                                                    Oleh-Oleh
                                                </MenuItem>
                                                <MenuItem value='Roti Dan Kue'>
                                                    Roti Dan Kue
                                                </MenuItem>
                                                <MenuItem value='Selai Dan Mentega'>
                                                    Selai Dan Mentega
                                                </MenuItem>
                                                <MenuItem value='Lainnya'>
                                                    Lainnya
                                                </MenuItem>
                                            </TextField>
                                            {this.validatorAdd.message('category', this.state.category, 'required')}
                                            <div className='text-danger'>{this.state.errors.category}</div>
                                        </div>
                                    </div>

                                    { this.state.category === 'Lainnya' &&
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='text'
                                                    id='name'
                                                    name='name'
                                                    label={text.label_category}
                                                    onChange={(e) => this.handleChange(e, 'category_other')}
                                                    value={this.state.category_other}
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors.category_other}</div>
                                            </div>
                                        </div>
                                    }

                                    <div className='col-md-4'>
                                        <div className='form-group'>
                                            <TextField
                                                type='number'
                                                id='weight'
                                                name='weight'
                                                label={text.label_weight}
                                                onChange={(e) => this.handleChange(e, 'weight')}
                                                value={this.state.weight}
                                                fullWidth
                                            />
                                            {this.validatorAdd.message('weight', this.state.weight, 'required')}
                                            <div className='text-danger'>{this.state.errors.weight}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-2 pl-0'>
                                        <span className='info'>Grams</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 mt-3 mb-2'>
                                <div className='alert-warning'>
                                    <p className='mb-0'>{text.product_alert}!</p>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='row align-items-center'>
                                    <div className='col-md-3'>
                                        <div className='form-group position-relative'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                            <div className='tooltip-image'>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <span>Horisontal</span>
                                                    <span>Vertikal</span>
                                                </div>
                                                <img src={Length} alt='length' className='img-fluid' />
                                            </div>
                                            <TextField
                                                type='number'
                                                id='length'
                                                name='length'
                                                label={text.label_length}
                                                onChange={(e) => this.handleChange(e, 'length')}
                                                value={this.state.length}
                                                fullWidth
                                            />
                                            {this.validatorAdd.message('length', this.state.length, 'required|numeric')}
                                            <div className='text-danger'>{this.state.errors.length}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='form-group position-relative'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                            <div className='tooltip-image'>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <span>Horisontal</span>
                                                    <span>Vertikal</span>
                                                </div>
                                                <img src={Width} alt='width' className='img-fluid' />
                                            </div>
                                            <TextField
                                                type='number'
                                                id='width'
                                                name='width'
                                                label={text.label_width}
                                                onChange={(e) => this.handleChange(e, 'width')}
                                                value={this.state.width}
                                                fullWidth
                                            />
                                            {this.validatorAdd.message('width', this.state.width, 'required|numeric')}
                                            <div className='text-danger'>{this.state.errors.width}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className='form-group position-relative'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                            <div className='tooltip-image'>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <span>Horisontal</span>
                                                    <span>Vertikal</span>
                                                </div>
                                                <img src={Height} alt='height' className='img-fluid' />
                                            </div>
                                            <TextField
                                                type='number'
                                                id='height'
                                                name='height'
                                                label={text.label_height}
                                                onChange={(e) => this.handleChange(e, 'height')}
                                                value={this.state.height}
                                                fullWidth
                                            />
                                            {this.validatorAdd.message('height', this.state.height, 'required|numeric')}
                                            <div className='text-danger'>{this.state.errors.height}</div>
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <label>{text.label_locker}</label>
                                        <span>
                                            { !this.state.loading3 && <span className='info'>{this.state.lockerSizeName !== 0 ? this.state.lockerSizeName : text.label_no_locker}</span> }
                                            { this.state.loading3 && <i className='fa fa-spinner fa-spin'>&nbsp; </i> }
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='row align-items-center'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <TextField
                                                select
                                                id='supliedPackaging'
                                                name='supliedPackaging'
                                                label={text.label_packaging}
                                                onChange={(e) => this.handleChange(e, 'supliedPackaging')}
                                                value={this.state.supliedPackaging}
                                                fullWidth
                                            >
                                                <MenuItem value='Vacuum Bag'>
                                                    Vacuum Bag
                                                </MenuItem>
                                                <MenuItem value='Plastic Bag'>
                                                    Plastic Bag
                                                </MenuItem>
                                                <MenuItem value='Other'>
                                                    Other
                                                </MenuItem>
                                            </TextField>
                                            {this.validatorAdd.message('supliedPackaging', this.state.supliedPackaging, 'required')}
                                            <div className='text-danger'>{this.state.errors.supliedPackaging}</div>
                                        </div>
                                    </div>

                                    {this.state.supliedPackaging === 'Other' &&
                                        <div className='col-md-4'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='text'
                                                    id='otherpackaging'
                                                    name='otherpackaging'
                                                    label={text.label_other}
                                                    onChange={(e) => this.handleChange(e, 'otherpackaging')}
                                                    value={this.state.otherpackaging}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('otherpackaging', this.state.otherpackaging, 'required')}
                                                <div className='text-danger'>{this.state.errors.otherpackaging}</div>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='row align-items-center'>
                                    <div className='col-md-4 mb-2'>
                                        <div className='form-group'>
                                            <TextField
                                                type='number'
                                                id='shelfLife'
                                                name='shelfLife'
                                                label={text.label_shelf}
                                                onChange={(e) => this.handleChange(e, 'shelfLife')}
                                                value={this.state.shelfLife}
                                                fullWidth
                                            />
                                            {this.validatorAdd.message('shelfLife', this.state.shelfLife, 'required')}
                                            <div className='text-danger'>{this.state.errors.shelfLife}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-2 pl-0'>
                                        <span className='info'>{text.label_days}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                        type='text'
                                        id='price'
                                        name='price'
                                        label={text.label_product_price}
                                        onChange={(e) => this.handleChange(e, 'price')}
                                        value={this.state.price}
                                        InputProps={{
                                            inputComponent: this.NumberFormatCustom,
                                        }}
                                        fullWidth
                                    />
                                    {this.validatorAdd.message('price', this.state.price, 'required')}
                                    <div className='text-danger'>{this.state.errors.price}</div>
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                        type='text'
                                        id='description'
                                        name='description'
                                        label={text.label_product_desc}
                                        onChange={(e) => this.handleChange(e, 'description')}
                                        value={this.state.description}
                                        fullWidth
                                        multiline
                                        rows={4}
                                    />
                                    {this.validatorAdd.message('description', this.state.description, 'required')}
                                    <div className='text-danger'>{this.state.errors.description}</div>
                                </div>
                            </div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='btn-link mr-3'
                            onClick={this.handleClose}
                            disabled={this.state.loadingButton || this.state.loading3 }
                        >
                            {text.button_back}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleAddProduct}
                            disabled={this.state.loadingButton || this.state.loading3 }
                        >
                            {text.button_add}{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialogSummary}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>{text.label_reservation_summary}</DialogTitle>
                    <DialogContent>
                        <table className="table table-borderless">
                            <thead style={{ borderBottom: `2px solid #d8d8d8`, fontSize: 12 }}>
                            <tr>
                                <th scope="col">SKU Produk SKU</th>
                                <th scope="col">Nama Produk</th>
                                <th scope="col">Jumlah</th>
                            </tr>
                            </thead>
                            <tbody style={{ fontSize: 14 }}>
                            {this.state.productList.map((item, i) => (
                                <tr key={i}>
                                    <td >{item.sku}</td>
                                    <td >{item.name}</td>
                                    <td>{item.quantity}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='btn-link mr-3'
                            onClick={this.handleClose}
                            disabled={this.state.loadingButton || this.state.loading3 }
                        >
                            {text.button_back}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleReservation}
                            disabled={!this.state.passed}
                        >
                            {text.button_next}
                            {!this.state.passed && this.state.step2 &&
                            <i className='fa fa-spinner fa-spin'> </i>
                            }
                        </Button>
                    </DialogActions>
                </Dialog>
            </main>
        )

    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Reservation);